import { classNames } from "primereact/utils";
import { Icon, IconType } from "../../../icons/Icon";
import { RenderWhen } from "../../../infrastructure/components/RenderWhen";
import styles from "./Persona.module.scss";

export interface IPersonaProps {
  className?: string;
  firstName: string;
  lastName?: string;
  email?: string;
  id: number;
  star?: boolean;
  onClick?: () => void;
}

export const Persona = ({
  className = "",
  firstName,
  lastName,
  email,
  id,
  star = false,
  onClick,
}: IPersonaProps) => {
  if (!id || !firstName) {
    return <></>;
  }
  return (
    <div
      className={classNames(styles.root, className, {
        [styles.root_clickable]: !!onClick,
      })}
      onClick={onClick}
    >
      <div className={styles.root_main}>
        {firstName} {lastName} <span>(#{id})</span>
        <RenderWhen condition={star}>
          <Icon type={IconType.Star} />
        </RenderWhen>
      </div>
      <div className={styles.root_email}>{email}</div>
    </div>
  );
};
